<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="m2.99878 21.0013h3.75l11.06002-11.06002-3.75-3.75-11.06002 11.06002z"
      />
      <path
        d="m18.3688 3.29128c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"
      />
    </g>
  </svg>
</template>
